import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'

export interface ManualTenantSummary {
  tenantId: string
  companyName: string | null
  nip: string | null
  package: number | null
  packageMultiplier: number
  activeDriversLimits: number | null
  monthlySubscription: boolean
  boundedPackage: boolean
  paid: boolean
  paymentDate: string | null
  subscriptionExpirationDate: string | null
  permanentlyBlocked: boolean
  suspendedFrom: string | null
  suspendedTo: string | null
}

export const MANUAL_TENANTS_QUERY_KEY = ['admin', 'billing', 'manual', 'tenants'] as const

export function useQueryManualTenants() {
  return useQuery<ManualTenantSummary[]>({
    queryKey: MANUAL_TENANTS_QUERY_KEY,
    queryFn: async () => {
      const res = await axiosInstance.get('/config-api/admin/billing/manual/tenants')
      return res.data
    },
  })
}

export function useMutationSetManualTenantBlocked() {
  const queryClient = useQueryClient()
  return useMutation<{ permanentlyBlocked: boolean }, unknown, { tenantId: string; blocked: boolean }>({
    mutationFn: async ({ tenantId, blocked }) => {
      const res = await axiosInstance.post(
        `/config-api/admin/billing/manual/tenants/${tenantId}/blocked`,
        { blocked },
      )
      return res.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MANUAL_TENANTS_QUERY_KEY })
    },
  })
}
